import { memo } from 'react'

import { DeleteOutline } from '@mui/icons-material'
import { Box, IconButton, Stack, Switch, TextField, Tooltip } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { StreamSelector } from '../StreamSelector'
import type { ConfigFormValues } from '../types'

export type GlobalAudioRowProps = {
  index: number
  repositoryId?: string
  streamEditable: boolean
  onRemove: () => void
}

const GlobalAudioRowRaw = ({ index, repositoryId, streamEditable, onRemove }: GlobalAudioRowProps) => {
  const { t } = useTranslation(['common', 'domain'])
  const { control } = useFormContext<ConfigFormValues>()

  return (
    <Stack direction="row" spacing={1.5} alignItems="center" sx={{ py: 1 }}>
      <Controller
        control={control}
        name={`globalAudioRows.${index}.name`}
        render={({ field }) => (
          <TextField
            {...field}
            size="small"
            sx={{ flex: 1 }}
            label={t('domain:Workspace.Event.ConfigEditor.audioName')}
          />
        )}
      />
      <Box sx={{ flex: 1.5 }}>
        <Controller
          control={control}
          name={`globalAudioRows.${index}.streamId`}
          render={({ field }) => (
            <StreamSelector
              repositoryId={repositoryId}
              kind="audio"
              streamId={field.value}
              disabled={!streamEditable}
              onChange={field.onChange}
            />
          )}
        />
      </Box>
      <Controller
        control={control}
        name={`globalAudioRows.${index}.enabled`}
        render={({ field }) => (
          <Tooltip title={t('domain:Workspace.Event.ConfigEditor.enabled')}>
            <Switch checked={field.value} onChange={(event) => field.onChange(event.target.checked)} />
          </Tooltip>
        )}
      />
      <Tooltip title={t('delete')}>
        <IconButton onClick={onRemove}>
          <DeleteOutline fontSize="small" />
        </IconButton>
      </Tooltip>
    </Stack>
  )
}

export const GlobalAudioRow = memo(GlobalAudioRowRaw)
